import React from 'react'
import "./warrantyAndRecoveryList.scss"

import SectionComponent from '../../../../components/utils/SectionComponent'
import { useTranslation } from 'react-i18next'

function WarrantyAndRecoveryList() {
  const { t } = useTranslation()

  return (
    <div className='container-warranty-and-recovery-list'>
      <div className="texts-warranty-and-recovery-list">
        <SectionComponent title={t("public_sector.warranty_list.warranty.title")} text={t("public_sector.warranty_list.warranty.section_text_1")}>
          <p>{t("public_sector.warranty_list.warranty.section_text_2")}</p>
        </SectionComponent>

        <SectionComponent title={t("public_sector.warranty_list.service_high.title")} text={t("public_sector.warranty_list.service_high.section_text")} />

        <SectionComponent title={t("public_sector.warranty_list.digital_reports.title")} text={t("public_sector.warranty_list.digital_reports.section_text_1")}>
          <p>{t("public_sector.warranty_list.digital_reports.section_text_2")}</p>
        </SectionComponent>

        <SectionComponent title={t("public_sector.warranty_list.performance_dashboard.title")} text={t("public_sector.warranty_list.performance_dashboard.section_text")} />
        <SectionComponent title={t("public_sector.warranty_list.project_status.title")} text={t("public_sector.warranty_list.project_status.section_text")} />
      </div>
    </div>
  )
}

export default WarrantyAndRecoveryList